import { render, staticRenderFns } from "./riesgoCardiovascularComponent.vue?vue&type=template&id=016c48ec"
import script from "./riesgoCardiovascularComponent.vue?vue&type=script&lang=js"
export * from "./riesgoCardiovascularComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports